/**
 * Utility functions for ScrollTrigger with iOS compatibility
 * Prevents ScrollTrigger from interfering with native momentum scrolling on iOS
 */
(function () {
  "use strict";

  function isIOSDevice() {
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isIPadOS =
      /Macintosh/.test(ua) &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 1;

    return isIOS || isIPadOS;
  }

  function registerScrollTrigger() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return false;
    }

    if (isIOSDevice()) {
      return false;
    }

    gsap.registerPlugin(ScrollTrigger);
    return true;
  }

  window.ScrollTriggerUtils = {
    register: registerScrollTrigger,
  };
})();
